import React, { FC, useState } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvComboboxOption,
	EvIcon,
	EvSelectNew,
	EvTextInput,
	OptionType,
	RemoveIcon
} from '@evinced-private/ui-common';

import { IScopeRuleUIFormat } from '../../../../interfaces/ScopeRuleUIFormat';
import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';

const TEXT_INPUT_PLACEHOLDER = 'e.g.https?://.*.example.com';
const ARIA_LABEL = 'URL Rule';
const REMOVE_URL_BUTTON_TITLE = 'Remove Url Rule';

const URL_ACTIONS: OptionType[] = [
	{ label: 'Include URLs', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude URLs', value: SCOPE_ACTIONS.EXCLUDE }
];

interface IUrlRuleRowProps {
	rule: IScopeRuleUIFormat;
	onRemove?: () => void;
	onRuleChange: (rule: IScopeRuleUIFormat) => void;
}

export const UrlRuleRow: FC<IUrlRuleRowProps> = ({ rule, onRemove, onRuleChange }) => {
	const [url, setUrl] = useState<string>(rule.url);
	const [selectedOption, setSelectedOption] = useState<EvComboboxOption>(
		URL_ACTIONS.find((option) => rule.scopeAction === option.value)
	);

	return (
		<div className="rule-row url-rule">
			<EvSelectNew
				id="url-rule-select"
				options={URL_ACTIONS}
				selectedValue={[selectedOption]}
				onSelectChange={(selectedItem: EvComboboxOption[]) => {
					setSelectedOption(selectedItem[0]);
					onRuleChange({
						...rule,
						scopeAction: selectedItem[0].value as SCOPE_ACTIONS
					});
				}}
				placeholder="Select URL Rule"
				label="URL Rule"
				className="rule-action-control"
			/>
			<EvTextInput
				ariaLabel={ARIA_LABEL}
				className="rule-value-control"
				value={url}
				placeholder={TEXT_INPUT_PLACEHOLDER}
				onChange={(val: string) => {
					setUrl(val);
					onRuleChange({ ...rule, url: val });
				}}
			/>
			<EvButton
				className="delete-rule-btn"
				key="Remove"
				title={REMOVE_URL_BUTTON_TITLE}
				type={BUTTON_TYPES.ICON}
				onClick={onRemove}
			>
				<EvIcon icon={RemoveIcon} />
			</EvButton>
		</div>
	);
};
